import React from 'react'
import './Keydates.css'
const Keydates = () => {
    return (
        <div className='Keydates'>
            <span className="heading">Key <span>dates</span></span>
            <table border="4">
                <tbody>
                    <tr>
                        <td>Submission Deadline:</td>
                        <td>
                            11 November 2026 
                        </td>

                    </tr>

                    <tr>
                        <td>Acceptance Notification:</td>
                        <td>15 November 2026</td>
                    </tr>

                    <tr>
                        <td>Final Paper Submission </td>
                        <td>15 December 2026</td>
                    </tr>

                    <tr>
                        <td>Conference:</td>
                        <td>21-22 January 2027</td>
                    </tr>

                </tbody>
            </table>
        </div>
    )
}

export default Keydates
